import React from 'react';
import PropTypes from 'prop-types';
import {
  useManagedAccountPageContext,
} from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Context/ManagedAccountPageContext';
import { Table } from '@facet-wealth/design';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import {
  MANAGED_ACCOUNT_ACTIVITY_TABLE_MOBILE_FIELDS,
} from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageTabPanel/Layouts/ManagedAccountTransactionTabPanelLayout';
import useMobileLayout from 'Hooks/useMobileLayout';
import {
  BODY_CELL_STATUS_OPTION_ERROR,
  BODY_CELL_STATUS_OPTION_PRIMARY,
  BODY_CELL_STATUS_OPTION_SUCCESS,
  BODY_CELL_STATUS_OPTION_UNKNOWN,
} from 'Consts/facetDesignLibrary';
import moment from 'moment';
import CapitalizeIFrameModal
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageTabPanel/Layouts/ManagedAccountTransactionTabPanelLayout/Content/IFrameModal/CapitalizeIFrameModal';


const getStatusForBodyCellStatus = (statusCategory) => {
  switch (statusCategory) {
    case 'success':
      return BODY_CELL_STATUS_OPTION_SUCCESS;
    case 'error':
      return BODY_CELL_STATUS_OPTION_ERROR;
    case 'pending':
      return BODY_CELL_STATUS_OPTION_PRIMARY;
    default:
      return BODY_CELL_STATUS_OPTION_UNKNOWN;
  }
};

const ManagedTransactionContent = () => {
  const isMobile = useMobileLayout();
  const { loadModalCollectionByLink } = useModalContext();
  const {
    managedAccountActivityCollection,
  } = useManagedAccountPageContext();
  const [iframeOpen, setIframeOpen] = React.useState(false);
  const [iframeUrl, setIframeUrl] = React.useState(null);

  const handleRowClick = (resource) => {
    resource.withRelationship(fr.relationships.additionalTransactionInformation.name,
      (rel) => {
        if (rel.meta('relationshipType') === 'linkModal') {
          loadModalCollectionByLink(rel.link('related').url());
        }
        if (rel.meta('relationshipType') === 'iframe') {
          setIframeOpen(true);
          setIframeUrl(rel);
        }
      },
      () => null);
  };

  const handleIframeClose = () => {
    setIframeOpen(false);
    setIframeUrl(null);
  };

  return (
    <>
      {iframeOpen && <CapitalizeIFrameModal rel={iframeUrl} open={iframeOpen} onClose={handleIframeClose} />}
      {
            managedAccountActivityCollection?.resources().list().map(resource => {
              return (
                <Table.BodyRow onClick={() => handleRowClick(resource)}>
                  {managedAccountActivityCollection
                    ?.meta()
                    .template()
                    .list()
                    .filter(field => (isMobile ? MANAGED_ACCOUNT_ACTIVITY_TABLE_MOBILE_FIELDS.includes(field.attr('name')) : true))
                    .filter(field => !field.attr('hidden'))
                    .map(field => {
                      const value = resource.attr(field.attr('name'));
                      if (field.attr('type') === 'number') {
                        return <Table.BodyCellNumber value={value} />;
                      }
                      if (field.attr('name') === 'status') {
                        return <Table.BodyCellStatus status={getStatusForBodyCellStatus(resource.attr('statusCategory'))} value={value} />;
                      }
                      if (isMobile && field.attr('name') === 'date') {
                        const mobileDate = moment(value).format('MMM D');
                        return <Table.BodyCellText value={mobileDate} />;
                      }
                      return <Table.BodyCellText value={value} />;
                    })
                  }
                </Table.BodyRow>);
            })
        }
    </>
  );
};

ManagedTransactionContent.defaultProps = {
  className: '',
};

ManagedTransactionContent.propTypes = {
  className: PropTypes.string,
};

export default ManagedTransactionContent;
